module.exports = __webpack_public_path__ + "img/earth.5cda7a9.webp";